import $ from 'jquery'

export default function initCampaignBanner() {
  function triggerCampaignBanner() {
    $('.c-campaign-banner-close').on('click', e => {
      e.preventDefault()
      $('.c-campaign-banner').remove()
    })
  }

  // if ($(window).width() > 600) {
  triggerCampaignBanner()
  // }
}
